<template>
  <div>
    <span>添加公众号成员</span>
    <el-form :model="ruleForm" :ref="ruleForm" label-width="120px" class="demo-ruleForm">
      <el-form-item label="账号:">
        <el-input v-model="ruleForm.calculate"></el-input>
      </el-form-item>
      <el-form-item label="姓名:">
        <el-input v-model="ruleForm.name"></el-input>
      </el-form-item>
      <el-form-item label="手机号:">
        <el-input v-model="ruleForm.cellphone"></el-input>
      </el-form-item>
      <el-form-item label="用户类型:">
        <el-input v-model="ruleForm.typeid" placeholder="电力用户" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="所属企业名称:">
        <el-select v-model="ruleForm.customername" placeholder="请选择企业名称">
          <el-option
            v-for="item in exchange"
            :key="item.id"
            :label="item.customername"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="登录密码:">
        <el-input v-model="ruleForm.password"></el-input>
      </el-form-item>
      <el-form-item label="确认密码:">
        <el-input v-model="ruleForm.password1"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="publicSubmit">提交</el-button>
        <el-button @click="$router.back(-1)">取消</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  name: "PublicEdit",
  data() {
    return {
      ruleForm: [],
      exchange: [], //遍历启用状态
      password1: ""
    };
  },
  created() {},
  mounted() {
    //遍历启用状态
    this.getDep();
  },
  methods: {
    //调取后端启用状态接口
    getDep: function() {
      const data = {};
      this.$http({
        method: "post",
        url: "/User/QueryClient"
      }).then(res => {
        console.log(res);
        this.exchange = res.data;
      });
    },
    // 保存页面
    publicSubmit() {
      // var reg = new RegExp("^(?=.*[a-z])(?=.*[A-Z])[a-zA-Z0-9~!@&%#_]{8,16}$");
      // if (!reg.test(this.ruleForm.password)) {
      //    this.$message({
      //     type: "success",
      //     message: "必须包含一个大写，一个小写字母，且长度为8到16位"
      //   });
      //   return;
      // }
      // if (this.ruleForm.password !== this.password1) {
      //     this.$message({
      //     type: "success",
      //     message: "新密码与确认不符，重新输入"
      //   });
      //   this.password1 = "";
      //   return;
      // }
      this.$http({
        method: "POST",
        url: "/User/AddUser",
        data: {
          calculate: this.ruleForm.calculate,
          name: this.ruleForm.name,
          cellphone: this.ruleForm.cellphone,
          typeid: this.ruleForm.typeid,
          enterpriseid: this.ruleForm.customername,
          password: this.ruleForm.password,
        }
      }).then(res => {
        this.$message({
          type: "success",
          message: "新增成功"
        });
        this.$router.push({ path: "../public" });
      });
    }
  }
};
</script>

<style lang='less' scoped>
.demo-ruleForm {
  margin: 30px 300px;
}
</style>